export default "__VITE_ASSET__DDsAs$LD__"